import * as React from 'react';

import { LocalizedText } from '@shared-ui/localization-context';

import { DateType } from 'constants/dates';

import { UitkDatePickerTriggeredSelector } from 'uitk-react-date-picker';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

import { CustomTriggerDateFieldWrapper } from 'components/infosite/shared-ui/form/date-field-custom-trigger';
import { StepperButton } from 'src/common/components/infosite/rooms-and-rates/availability-wizard/internals/stepper-button';

export interface DateStepperProps {
  clickHandler: (event: Event, isTriggeredByStepper?: boolean) => void;
  endDate: string;
  startDate: string;
  dateType: DateType;
  buttonText: string;
  invalid?: string;
  midnightBookingOffsetHours: number;
  numDaysBookableInAdvance: number;
}

export class DateStepper extends React.Component<DateStepperProps> {
  public render() {
    return (
      <UitkSpacing margin={{ block: 'three' }}>
        <div className="pwa-theme--grey-700">
          <DateStepperWrapper {...this.props} />
        </div>
      </UitkSpacing>
    );
  }
}

const DateStepperWrapper = (props: DateStepperProps) => {
  const { dateType } = props;
  let dateStepperLabelKey;
  let stepperButtonLinkName;
  let stepperButtonRfrr;
  let stepperButtonType;
  if (dateType === DateType.CHECK_IN) {
    dateStepperLabelKey = 'hotels.search.form.fromDateHyphen.label';
    stepperButtonLinkName = 'Check-in Date';
    stepperButtonRfrr = ':ChangeDatesCheckIn';
    stepperButtonType = 'CHECK_IN';
  } else if (dateType === DateType.CHECK_OUT) {
    dateStepperLabelKey = 'hotels.search.form.toDateHyphen.label';
    stepperButtonLinkName = 'Check-out Date';
    stepperButtonRfrr = ':ChangeDatesCheckOut';
    stepperButtonType = 'CHECK_OUT';
  }
  const stepperProps = {
    stepperButtonLinkName,
    stepperButtonRfrr,
    stepperButtonType,
    ...props,
  };

  return (
    <>
      <UitkLayoutFlexItem>
        <UitkText size={200}>
          <LocalizedText message={dateStepperLabelKey || ''} />
        </UitkText>
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>
        <UitkSpacing padding={{ blockstart: 'one' }}>
          <div>
            <UitkLayoutGrid columns={6}>
              <UitkLayoutGridItem colSpan={1}>
                <MinusOneDayStepper {...stepperProps} />
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={4}>
                <UitkText size={400}>
                  <span data-stid="content-wizard-checkin">
                    <CustomTriggerHelper {...props} />
                  </span>
                </UitkText>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={1}>
                <PlusOneDayStepper {...stepperProps} />
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </div>
        </UitkSpacing>
      </UitkLayoutFlexItem>
    </>
  );
};

const MinusOneDayStepper = (props: any) => {
  const { clickHandler, endDate, startDate, stepperButtonLinkName, stepperButtonRfrr, stepperButtonType } = props;

  return (
    <StepperButton
      clickHandler={clickHandler}
      endDate={endDate}
      linkName={`${stepperButtonLinkName} Minus One Day`}
      rfrr={`${stepperButtonRfrr}:MinusOneDay`}
      startDate={startDate}
      stepperType={`${stepperButtonType}_MINUS`}
    />
  );
};

const PlusOneDayStepper = (props: any) => {
  const { clickHandler, endDate, startDate, stepperButtonLinkName, stepperButtonRfrr, stepperButtonType } = props;

  return (
    <StepperButton
      clickHandler={clickHandler}
      endDate={endDate}
      linkName={`${stepperButtonLinkName} Plus One Day`}
      rfrr={`${stepperButtonRfrr}:PlusOneDay`}
      startDate={startDate}
      stepperType={`${stepperButtonType}_PLUS`}
    />
  );
};

export const CustomTriggerHelper = (props: any) => <CustomTriggerDateFieldWrapper {...getCommonDateFieldProps(props)} />;

export const getCommonDateFieldProps = (props: DateStepperProps) => {
  const { clickHandler, dateType, ...dateFieldProps } = props;
  let triggeredSelector;
  let dateFieldRfrr;
  if (dateType === DateType.CHECK_IN) {
    triggeredSelector = UitkDatePickerTriggeredSelector.START;
    dateFieldRfrr = ':ChangeDatesCheckIn';
  } else if (dateType === DateType.CHECK_OUT) {
    triggeredSelector = UitkDatePickerTriggeredSelector.END;
    dateFieldRfrr = ':ChangeDatesCheckOut';
  }

  return {
    triggeredSelector,
    onChange: clickHandler,
    rfrr: dateFieldRfrr,
    ...dateFieldProps,
  };
};
